import api from "./api";
import { history } from "./history";

export const drawingTypeOf = (w, h) => (w && h ? (w > h ? "landscape" : "portrait") : null);

// Coarse 3x3 location of a normalized box on the page ("top-left" .. "bottom-right").
export const locationOf = (box) => {
    if (!box || box.length !== 4) return null;
    const cx = (box[0] + box[2]) / 2, cy = (box[1] + box[3]) / 2;
    const v = cy < 0.33 ? "top" : cy > 0.66 ? "bottom" : "middle";
    const h = cx < 0.33 ? "left" : cx > 0.66 ? "right" : "center";
    return `${v}-${h}`;
};

export const feedbackItem = (it, key, kind, value) => ({
    field: key, kind,
    ai_value: it.f[key]?.orig == null ? null : String(it.f[key].orig),
    value: value == null ? null : String(value),
    position: String(it.f.name?.value ?? "").slice(0, 60) || null,
    location: locationOf(it.f[key]?.box),
    page: it.page,
});

export async function sendAiFeedback(projectId, items, drawingType) {
    if (!projectId || !items.length) return;
    const body = { items, drawing_type: drawingType || null };
    history.attach({
        label: "AI",
        undo: () => api.post(`/projects/${projectId}/ai-feedback-undo`, body).catch(() => {}),
        redo: () => api.post(`/projects/${projectId}/ai-feedback`, body).catch(() => {}),
    });
    try { await api.post(`/projects/${projectId}/ai-feedback`, body); } catch { /* learning is best-effort */ }
}
